// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date___44CP","head":"ProcedureTableInfo_head__3kK7w"};